'use client'

import { useState } from 'react'
import Button from '@/components/ui/Button'
import ContactFormModal from '@/components/ContactFormModal'
import { FaEnvelope } from 'react-icons/fa'

export default function ContactPageButton() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        size="lg"
        className="w-full flex items-center justify-center gap-2"
      >
        <FaEnvelope />
        Bilgi Al
      </Button>
      
      <ContactFormModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  )
}

